import { BatchLimitationInteractor, BatchLimitationRequest, BatchLimitationStructRequest} from "../../Coordinator/BatchLimitation/BatchLimitationInteractor";

export class BatchLimitationViewModel {
    private interactor: BatchLimitationInteractor;

	constructor() {
		this.interactor = new BatchLimitationInteractor();
	}

    public fetchSave(obj: any): PromiseLike<any> {
        var request = new BatchLimitationRequest(
            obj["sgeplimitacaolote"] ? parseInt(obj["sgeplimitacaolote"]) : 0,
            obj["nome"] ? obj["nome"] : ""
        )
        
        return new Promise((res, rej) => {
			this.interactor.fetchSave(request).then((result) => {
				return res()
			}, e => {
				return rej(e)
			});
		})
    }

    public fetchDataOne(obj: any): PromiseLike<any> {
        var request = new BatchLimitationStructRequest(
            obj["sgeplimitacaolote"] ? parseInt(obj["sgeplimitacaolote"]) : 0
        )
        
        return new Promise((res, rej) => {
			this.interactor.fetchDataOne(request).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
    }
}